export default "__VITE_ASSET__c337b52b__"